export default {
    reviewOrder: {
        reviewOrder: "Megrendelés áttekintése"
    }
}